<template>
    <div>
      <full-card>
            <template v-slot:header>
                <div class="flex justify-between items-center">
                    <button-secondary @click="prev()" class="mr-2">
                        <template slot="icon"><i class="fa fa-calendar-minus-o"></i></template>
                    </button-secondary>
                    <div class="flex justify-center">Konferenzraum Buchungen am {{ asDay(date) }}</div>
                    <button-secondary @click="next()">
                        <template slot="icon"><i class="fa fa-calendar-plus-o"></i></template>
                    </button-secondary>
                </div>

            </template>
            <loading v-show="loading"></loading>
            <div v-if="!loading">
                <chart-line
                    :datasets="dataset"
                    :labels="labels"
                    :show-export="showInput"
                    :headline="headline"
                ></chart-line>
            </div>
        </full-card>
    </div>
</template>

<script>

import Headline from "../components/UI/Headline.vue"
import ButtonSecondary from "../components/UI/ButtonSecondary.vue"
import ButtonPrimary from "../components/UI/ButtonPrimary.vue"
import SelectMenu from "../components/UI/SelectMenu.vue"
import Modal from "../components/Modal.vue";
import InputText from "../components/UI/InputText.vue";
import Loading from "../components/UI/Loading.vue";
import ChartLine from "../components/Chart/ChartLine";
import FullCard from "../components/UI/FullCard";
import moment from "moment/moment";
import format from "date-fns/format"

export default {
    name: "ConferenceRoomHourlyStatistic",
    components: {

        Headline,
        ButtonSecondary,
        SelectMenu,
        Modal,
        ButtonPrimary,
        InputText,
        Loading,
        ChartLine,
        FullCard
    },

    data: () => ({
        loading: false,
        floors: [],
        bookings: [],
        conferenceRoomsCount: [],
        dataset: [],
        labels: [],
        headline: '',
        showInput: true,
        zoneId: null,
        floorId: null,
        disableWatch: false,
        date: new Date().toISOString().slice(0, 10),
    }),

    mounted() {
        this.load();
    },

    watch: {
      floorId(){
        if(!this.disableWatch) {
          this.disableWatch = true;
          this.zoneId = null;
          setTimeout(function () { this.disableWatch = false; }.bind(this)  , 100);
        }
      },
      date(){
        this.load();
      }
    },

    computed: {
        textFloors() {
            return ['Alle'].concat(this.floors.map(p => p.name));
        },
        valuesFloors() {
            return [null].concat(this.floors.map(p => p.id));
        },
    },

    methods: {
        load() {
            this.loading = true;
            let params = {
                periodicity: this.filter,
                zone: '',
                floor: this.floorId,
                date: this.date,
          }
          this.$http.get('/admin/conference_room_hourly_statistic', {
               params
            }).then(result => {
                this.loading = false;
                this.labels = Object.keys(result.data.hourly);
                this.bookings = Object.values(result.data.hourly);       
                this.conferenceRoomsCount = result.data.conferenceRoomsCount;
                this.dataset = [{
                            label: 'Konferenzraum Buchungen',
                            data: this.bookings,
                            borderColor: '#F1948A',
                            fill: false,
                            tension: 0.1,
                }];
            }).catch(error => {
                this.$root.$emit('error', error);
            })

        },
        setLoading(flag){
            this.loading = flag;
        },
        asDay(day) {
            return format(new Date(day), 'dd.MM.');
        },
        next() {
            this.date = moment(this.date).add(1, 'day');
            this.load(this.date._d);
        },
        prev() {
            this.date = moment(this.date).subtract(1, 'day');
            this.load(this.date._d);
        },
    }
}
</script>

